import { render, staticRenderFns } from "./coupon-item-open.vue?vue&type=template&id=36a22c15&scoped=true&lang=pug&"
import script from "./coupon-item-open.vue?vue&type=script&lang=js&"
export * from "./coupon-item-open.vue?vue&type=script&lang=js&"
import style0 from "./coupon-item-open.vue?vue&type=style&index=0&id=36a22c15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a22c15",
  null
  
)

export default component.exports